var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5854 17.1039C33.5854 7.65767 26.067 0 16.7927 0C7.51833 0 0 7.65767 0 17.1039C0 25.6408 6.14081 32.7169 14.1688 34V22.048H9.90506V17.1039H14.1688V13.3357C14.1688 9.04903 16.6759 6.68121 20.5117 6.68121C22.3484 6.68121 24.2707 7.01527 24.2707 7.01527V11.2244H22.1532C20.0673 11.2244 19.4165 12.543 19.4165 13.8969V17.1039H24.0739L23.3294 22.048H19.4165V34C27.4446 32.7169 33.5854 25.6408 33.5854 17.1039Z",
    fill: "#A0A3BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.384b35da2afafb55c933abb3a12bf93d.svg";
export { ForwardRef as ReactComponent };